export const hospitalDataDocNewColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'created_date',
  'fk_hospital__encounter_master_id',
  'fk_hospital__organization_id',
  'fk_hospital__patient_id',
  'snapshot_id',
];
